import { useState } from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import { ContactCallbackModal } from './ContactCallbackModal';
import logo from '@/assets/logo-optimized.png';
export function LandingFooter() {
  const [contactModalOpen, setContactModalOpen] = useState(false);

  return (
    <>
      <footer className="border-t bg-card py-12">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Brand */}
            <div className="md:col-span-2">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <img src={logo} alt="RepriScan" className="h-10 w-10" />
                <span className="font-bold text-lg">RepriScan</span>
              </Link>
              <p className="text-sm text-muted-foreground max-w-sm">
                L'outil de prédiagnostic pour les repreneurs d'entreprise. 
                Analysez vos dossiers rapidement et décidez en toute clarté.
              </p>
            </div>
            
            {/* Links */}
            <div>
              <p className="font-semibold mb-4">Produit</p>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li>
                  <Link to="/pricing" className="hover:text-foreground transition-colors">
                    Tarifs
                  </Link>
                </li>
                <li>
                  <Link to="/auth" className="hover:text-foreground transition-colors">
                    S'inscrire
                  </Link>
                </li>
                <li>
                  <Link to="/auth" className="hover:text-foreground transition-colors">
                    Se connecter
                  </Link>
                </li>
                <li>
                  <button 
                    onClick={() => setContactModalOpen(true)}
                    className="inline-flex items-center gap-1.5 hover:text-foreground transition-colors"
                  >
                    <MessageCircle className="h-3.5 w-3.5" />
                    Contact
                  </button>
                </li>
              </ul>
            </div>
            
            {/* Legal */}
            <div>
              <p className="font-semibold mb-4">Légal</p>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li>
                  <Link to="/mentions-legales" className="hover:text-foreground transition-colors">
                    Mentions légales
                  </Link>
                </li>
                <li>
                  <Link to="/politique-confidentialite" className="hover:text-foreground transition-colors">
                    Politique de confidentialité
                  </Link>
                </li>
                <li>
                  <Link to="/cgu" className="hover:text-foreground transition-colors">
                    CGU
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          
          <div className="border-t mt-8 pt-8 text-center text-sm text-muted-foreground">
            <p>© {new Date().getFullYear()} RepriScan. Tous droits réservés.</p>
          </div>
        </div>
      </footer>

      <ContactCallbackModal 
        open={contactModalOpen} 
        onOpenChange={setContactModalOpen} 
      />
    </>
  );
}